import { TrainingsSessionScheduleEnum } from 'generated/resources/datatable.graphql'
import moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

export const formatSessionDate = ({
  startsAt,
  endsAt,
  dueDate,
  duration,
  schedule,
}: {
  startsAt: string | null
  endsAt: string | null
  duration?: string | null
  dueDate?: string | null
  schedule?: TrainingsSessionScheduleEnum | null
}) => {
  const startDate = startsAt && dateToString(moment(startsAt), 'ui_dm_long')
  const endDate = dueDate && dateToString(moment(dueDate), 'ui_dm_long')
  const start = startsAt && dateToString(moment(startsAt), 'ui_time')
  const end = endsAt && dateToString(moment(endsAt), 'ui_time')

  const formatDuration = (duration?: string | null) => {
    if (!duration) return ''
    const totalMinutes = parseFloat(duration) * 60
    const hours = Math.floor(totalMinutes / 60)
    const minutes = Math.round(totalMinutes % 60)
    return `${hours}h ${minutes}m`
  }

  if (schedule === 'scheduled') {
    return `${startDate},  ${start} - ${end} (${formatDuration(duration)})`
  }

  if (startDate && !endDate) {
    return `${startDate} ${duration ? `, ${formatDuration(duration)}` : ''}`
  } else if (!startDate && endDate) {
    return `${endDate} ${duration ? `, ${formatDuration(duration)}` : ''}`
  } else if (startDate && endDate) {
    return `${startDate} - ${endDate} ${duration ? `, ${formatDuration(duration)}` : ''}`
  }

  return ''
}

export const getStatusLabel = (status: string) => {
  switch (status) {
    case 'approved':
      return i18n.t('trainings.training_requests.header.status.approved')
    case 'draft':
      return i18n.t('trainings.training_requests.header.status.draft')
    case 'review':
      return i18n.t('trainings.training_requests.header.status.pending')
    default:
      return i18n.t('trainings.training_requests.header.status.rejected')
  }
}

export const getStatusVariant = (status: string) => {
  switch (status) {
    case 'approved':
      return 'positive'
    case 'draft':
      return 'neutral'
    case 'review':
      return 'warning'
    default:
      return 'critical'
  }
}
